{
  "name": "service-planning",
  "version": "3.2.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "start-opt": "ng serve --configuration=test --port=4500 -o",
    "start-dev": "ng serve --configuration=dev --port=4500 -o",
    "start-prod": "ng serve --configuration=production --port=4500 -o",
    "start-local": "ng serve --configuration=local --port=4500 -o",
    "build": "ng build",
    "build-test": "ng build --configuration=test",
    "build-dev": "ng build --configuration=dev",
    "build-prod": "ng build --configuration=production",
    "test": "npx jest src/app/ --coverage",
    "serve-test": "angular-http-server --path ./dist/test -p 4500",
    "e2e": "npx playwright test",
    "e2e-ui": "npx playwright test --ui",
    "lint": "eslint --color -c eslint.config.js --ext .ts ./src/app/",
    "lint:fix": "eslint --fix --ext .ts ./src/app",
    "format:fix": "pretty-quick --staged",
    "format": "pretty-quick",
    "i18n:add-keys": "node i18n/scripts/add-translation-keys.js",
    "i18n:validate": "node i18n/scripts/validate-translations.js",
    "i18n:cleanup": "node i18n/scripts/cleanup-translations.js",
    "i18n:cleanup:dry-run": "node i18n/scripts/cleanup-translations.js --dry-run",
    "precommit": "run-s format:fix lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.8",
    "@angular/cdk": "^22.1.8",
    "@angular/common": "^22.1.8",
    "@angular/core": "^22.1.8",
    "@angular/forms": "^22.1.8",
    "@angular/material": "^22.1.8",
    "@angular/platform-browser": "^22.1.8",
    "@angular/platform-browser-dynamic": "^22.1.8",
    "@angular/router": "^22.1.8",
    "@angular/service-worker": "^22.1.8",
    "@datadog/browser-rum": "^7.4.0",
    "@here/maps-api-for-javascript": "^1.66.0",
    "@myscania/myscania-chat-widget": "^1.4.7",
    "@myscania/scope": "^8.0.2",
    "@myscania/translation-utils-angular": "^19.0.0",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@ng-select/ng-select": "^23.11.0",
    "@ngrx/effects": "^22.0.1",
    "@ngrx/entity": "^22.0.1",
    "@ngrx/router-store": "^22.0.1",
    "@ngrx/schematics": "^22.0.1",
    "@ngrx/store": "^22.0.1",
    "@ngrx/store-devtools": "^22.0.1",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@scania/colour": "^2.0.1",
    "@scania/grid": "^2.0.1",
    "@scania/icons": "^1.1.1",
    "@scania/tegel": "^1.59.1",
    "@scania/tegel-angular-17": "^1.59.1",
    "@scania/theme-light": "^4.4.1",
    "@schematics/angular": "^22.1.8",
    "@teamsp/components": "^4.0.1",
    "angular-calendar": "^0.32.2",
    "angular-draggable-droppable": "^9.0.1",
    "angular-resizable-element": "^8.0.3",
    "angular-shepherd": "^20.0.0",
    "bootstrap": "^5.3.3",
    "date-fns": "^4.4.0",
    "dayjs": "^1.11.11",
    "dotenv": "^17.2.1",
    "guid-typescript": "^1.0.9",
    "js-quantities": "^1.8.0",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^23.0.6",
    "launchdarkly-js-client-sdk": "^3.4.0",
    "rrule": "^2.6.8",
    "rxjs": "7.8.1",
    "shepherd.js": "^13.0.0",
    "tslib": "2.6.3",
    "zone.js": "~0.15.1"
  },
  "overrides": {
    "angular-shepherd": {
      "shepherd.js": "^13.0.0"
    }
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.8",
    "@angular-eslint/eslint-plugin": "^19.8.0",
    "@angular-eslint/eslint-plugin-template": "^19.8.0",
    "@angular-eslint/template-parser": "^19.8.0",
    "@angular/cli": "^22.1.8",
    "@angular/compiler": "^22.1.8",
    "@angular/compiler-cli": "^22.1.8",
    "@babel/core": "^7.24.8",
    "@babel/preset-env": "^7.24.8",
    "@eslint/compat": "^1.3.1",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.31.0",
    "@playwright/test": "^1.56.1",
    "@types/jest": "^29.5.12",
    "@types/js-quantities": "^1.6.6",
    "@types/node": "22.13.17",
    "@typescript-eslint/eslint-plugin": "^8.50.1",
    "@typescript-eslint/parser": "^8.50.1",
    "angular-http-server": "^1.12.0",
    "babel-loader": "^9.1.3",
    "eslint": "^9.39.2",
    "eslint-plugin-jest": "^28.6.0",
    "globals": "^16.3.0",
    "jest": "^30.2.0",
    "jest-canvas-mock": "^2.5.2",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^16.1.1",
    "playwright": "^1.56.1",
    "prettier": "^3.6.2",
    "pretty-quick": "4.0.0",
    "ts-loader": "^9.5.1",
    "typescript": "~6.0.3",
    "webpack": "^5.99.9"
  }
}
